/**
 * build a corporate api url
 * @param path
 * @param host
 * @param version
 * @param scope
 * @param https
 * @returns
 */
export default function buildApiUrl(
  path: string,
  host?: string,
  version = 5,
  scope = 'corporate-api'
): string {
  const url: string[] = [];
  // host
  host && url.push(`https://${host}`);
  // prefix
  url.push(`/api/v${version}/${scope}`);
  // path
  !path.startsWith('/') && (path = `/${path}`);
  url.push(path);

  return url.join('');
}
